
import ByUserListView from "../../backyard/view/user/List.vue";
import ByUserProfile from "../../backyard/view/user/Profile.vue";
import ByUserEdit from "../../backyard/view/user/Edit.vue";


let lbUserRouter = [

];

let byUserRouter = [
	{
		path: 'user/list',
		name: "userList",
		component: ByUserListView,
		meta: {
			requiresAuth: true,
			breadcrumbs: []
		}
	},
	{
		path: 'user/profile/:id',
		name: "userProfile",
		component: ByUserProfile,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "userProfile",
					title: "个人中心"
				}
			]
		}
	},
	{
		path: 'user/edit/:id',
		name: "userEdit",
		component: ByUserEdit,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "userEdit",
					title: "编辑个人信息"
				}
			]
		}
	}
];


export {lbUserRouter, byUserRouter}





// WEBPACK FOOTER //
// ./src/common/router/UserRouter.js